import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { IThreeDSResponse, ThreeDSStatus } from '@nibtravel/shared/util/models';

import {
  IPaymentState,
  IThreeDSInfo,
  IPaymentValidation,
  IPaymentVerification,
} from '../models';
import { PaymentActions } from './payment.action';

@State<IPaymentState>({
  name: 'payment',
  defaults: {},
})
@Injectable()
export class PaymentState {
  @Selector()
  public static getState(state: IPaymentState): IPaymentState {
    return state;
  }

  @Selector()
  public static verification(
    state: IPaymentState
  ): IPaymentVerification | { type: null } {
    return (
      state.verification || {
        type: null,
      }
    );
  }

  @Selector()
  public static threeDSResponseInfo(
    state: IPaymentState
  ): IThreeDSInfo | undefined {
    return state.threeDSResponseInfo;
  }

  @Selector()
  public static errors(state: IPaymentState): IPaymentValidation | undefined {
    return state.validation;
  }

  @Action(PaymentActions.Reset)
  resetState(ctx: StateContext<IPaymentState>): void {
    ctx.setState({});
  }

  @Action(PaymentActions.Update)
  updateState(
    ctx: StateContext<IPaymentState>,
    { threeDSResponseInfo, cardToken, paymentIds }: PaymentActions.Update
  ): void {
    if (
      threeDSResponseInfo &&
      threeDSResponseInfo.threeDSStatus &&
      threeDSResponseInfo.threeDSResponse
    ) {
      const threeDSResponse: IThreeDSResponse = JSON.parse(
        threeDSResponseInfo.threeDSResponse
      );

      const threeDSStatus = threeDSResponseInfo.threeDSStatus;

      const frameStyle =
        threeDSStatus === ThreeDSStatus.CHALLENGE
          ? {
              height: 800,
              width: '100%',
            }
          : threeDSStatus === ThreeDSStatus.REDIRECT
          ? {
              height: 800,
              width: '100%',
            }
          : undefined;

      const verification: IPaymentVerification = {
        type: threeDSStatus,
        formUrl: threeDSResponse.threeDSMethodUrl,
        formParameters: JSON.parse(threeDSResponse.threeDSMethodData),
        responseOrigin: threeDSResponse.threeDSOrigin,
        frameStyle,
      };

      ctx.setState(
        patch({
          verification,
          threeDSResponseInfo: {
            cardToken,
            paymentIds,
            paymentData: threeDSResponse.paymentData,
            threeDSRequestPattern: threeDSResponseInfo.threeDSRequestPattern,
            threeDSStatus,
          },
        })
      );
    }
  }

  @Action(PaymentActions.ResetErrors)
  resetErrors(ctx: StateContext<IPaymentState>): void {
    ctx.patchState({
      validation: undefined,
    });
  }

  @Action(PaymentActions.SetErrors)
  setErrors(
    ctx: StateContext<IPaymentState>,
    { errorCode, errorMessage }: PaymentActions.SetErrors
  ): void {
    ctx.patchState({
      validation: {
        code: errorCode,
        message: errorMessage,
      },
    });
  }
}
